import Vue from 'vue';
import { BfButton } from 'components/Butterfly';
const UnsubscribedPage = Vue.extend({
    components: { BfButton },
    computed: {
        resubLink() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            return params.resub_link;
        }
    },
    mounted() {
        this.$analytics.track.dashboard.digest.userUnsubscribed();
    },
    methods: {
        resubscribe() {
            this.$analytics.track.dashboard.digest.userResubscribed();
            if (this.resubLink) {
                window.location.href = this.resubLink;
            }
        }
    }
});
export default UnsubscribedPage;
